import createHistory from 'history/createHashHistory'
import qs from 'query-string'

const history = createHistory()

export default history
export const push = (path) => {
  const token = qs.parse(location.hash.split('?').pop()).token || localStorage.getItem('token')
  if (token) history.push(`${path}?token=${token}`)
  else history.push(path)
}



// WEBPACK FOOTER //
// ./src/history.js